import measureTextWidth from '../_util/measureTextWidth';
function getContentWidth(element, computedStyle) {
    const { width, boxSizing } = computedStyle;
    if (boxSizing === 'content-box' && width && width !== 'auto') {
        return parseFloat(width);
    }
    const contentWidth = width && width !== 'auto' ? parseFloat(width) : element.offsetWidth;
    const { paddingLeft, paddingRight, borderLeftWidth, borderRightWidth } = computedStyle;
    const pl = paddingLeft ? parseFloat(paddingLeft) : 0;
    const pr = paddingRight ? parseFloat(paddingRight) : 0;
    const bl = borderLeftWidth ? parseFloat(borderLeftWidth) : 0;
    const br = borderRightWidth ? parseFloat(borderRightWidth) : 0;
    return contentWidth - pl - pr - bl - br;
}
export default function isOverflow(element) {
    const { textContent, ownerDocument } = element;
    if (textContent && ownerDocument) {
        const { clientWidth, scrollWidth } = element;
        if (scrollWidth > clientWidth) {
            return true;
        }
        const { defaultView } = ownerDocument;
        if (defaultView) {
            const computedStyle = defaultView.getComputedStyle(element);
            const contentWidth = getContentWidth(element, computedStyle);
            const textWidth = measureTextWidth(textContent, computedStyle);
            return textWidth > contentWidth;
        }
    }
    return false;
}
